import { render, staticRenderFns } from "./ApplicationDetails.vue?vue&type=template&id=438f3489&"
import script from "./ApplicationDetails.vue?vue&type=script&lang=ts&"
export * from "./ApplicationDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports